import { CombinedGraphQLErrors } from '@apollo/client/errors'

/**
 * graphql-api's updatePerson refuses a card number that another person already has
 * (`src/db/person/updatePerson.ts`). The person who typed it needs to hear that — "try again later"
 * never helps — and it is an expected answer, not a defect, so it stays out of Sentry. The same
 * pattern keeps the errorLink from reporting it (`SUPPRESSED_ERROR_MESSAGES`).
 */
export const RFID_COLLISION = /^RFID collision$/

export const isRfidCollision = (err: unknown): boolean =>
  CombinedGraphQLErrors.is(err) && err.errors.some((e) => RFID_COLLISION.test(e.message))
